declare global {
  interface Window {
    JXG?: any;
  }
}

let loaderPromise: Promise<any> | null = null;

export function loadJSXGraph(): Promise<any> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('JSXGraph can only be loaded in browser'));
  }

  if (window.JXG) {
    return Promise.resolve(window.JXG);
  }

  if (!loaderPromise) {
    loaderPromise = (async () => {
      const mod = await import('jsxgraph');
      const JXG = (mod as any).default || mod;

      if (!window.JXG) {
        window.JXG = JXG;
      }

      return window.JXG;
    })();
  }

  return loaderPromise;
}
